var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1H8.5V2H9.5H10.5V3V4V5V10V11H9.5H2.5H1.5V10V5V4V3V2H2.5H3.5V1H4.5V2H7.5V1ZM4.5 3H3.5H2.5V4H9.5V3H8.5H7.5H4.5ZM2.5 5V10H9.5V5H2.5ZM3.5 6H4.5V7H3.5V6ZM6.5 6H5.5V7H6.5V6ZM7.5 6H8.5V7H7.5V6ZM4.5 8H3.5V9H4.5V8ZM5.5 8H6.5V9H5.5V8ZM8.5 8H7.5V9H8.5V8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarS);
export default __webpack_public_path__ + "static/media/calendar-s.9216986c3277fc5cadfd2c943b008184.svg";
export { ForwardRef as ReactComponent };